import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { Dashboard } from '../../models/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseService<Dashboard> {
  constructor(protected http: HttpClient) {
    super(http, 'dashboard');
  }
}
